import { render, staticRenderFns } from "./SubmitButton-Branche.vue?vue&type=template&id=9d62c66e&scoped=true&"
import script from "./SubmitButton-Branche.vue?vue&type=script&lang=js&"
export * from "./SubmitButton-Branche.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButton-Branche.vue?vue&type=style&index=0&id=9d62c66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d62c66e",
  null
  
)

export default component.exports